import { alimpCommonJump, alipayCommonJump, cowxmpCommonJump, driverCommonJump, drwxmpCommonJump, gjwxmpCommonJump, h5CommonJump, kfalimpCommonJump, kfdriverCommonJump, kfdwxmpCommonJump, yxwxmpCommonJump, kfpassengerCommonJump, kfwxmpCommonJump, passengerCommonJump, esappCommonJump, qjwxmpCommonJump, thwxmpCommonJump, weixinCommonJump, wxmpCommonJump, dympCommonJump, mqqCommonJump, gaswxmpCommonJump, hitchappCommonJump, sfcwxmpCommonJump, sfcalimpCommonJump, hywxmpCommonJump, hyalimpCommonJump, hydriverCommonJump, cralimpCommonJump, eshwxmpCommonJump } from '../platform/xenv';
const xenvCommonJump = {
    'alimp': alimpCommonJump,
    'alipay': alipayCommonJump,
    // 'bdmp': '',
    'cowxmp': cowxmpCommonJump,
    'sfcwxmp': sfcwxmpCommonJump,
    'sfcalimp': sfcalimpCommonJump,
    'driver': driverCommonJump,
    'drwxmp': drwxmpCommonJump,
    'gjwxmp': gjwxmpCommonJump,
    'h5': h5CommonJump,
    'kfalimp': kfalimpCommonJump,
    'kfdriver': kfdriverCommonJump,
    'kfdwxmp': kfdwxmpCommonJump,
    'kfpassenger': kfpassengerCommonJump,
    'kfwxmp': kfwxmpCommonJump,
    'mqq': mqqCommonJump,
    'passenger': passengerCommonJump,
    'esapp': esappCommonJump,
    'qjwxmp': qjwxmpCommonJump,
    // 'qqmp': '',
    'thwxmp': thwxmpCommonJump,
    'weixin': weixinCommonJump,
    'wxmp': wxmpCommonJump,
    'dymp': dympCommonJump,
    'yxwxmp': yxwxmpCommonJump,
    'gaswxmp': gaswxmpCommonJump,
    'hitchapp': hitchappCommonJump,
    'hywxmp': hywxmpCommonJump,
    'hyalimp': hyalimpCommonJump,
    'hydriver': hydriverCommonJump,
    'cralimp': cralimpCommonJump,
    'eshwxmp': eshwxmpCommonJump,
};
let commonJump;
let doCommonJumpFn = (loadParams = {}, xenv, params = {}) => {
    commonJump = xenvCommonJump[xenv];
    commonJump(loadParams, xenv, params);
};
export { doCommonJumpFn as doCommonJump };
